import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { All_LIST_QUESTION, All_LIST_QUESTION_CLEAR } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllListQuestionDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadAllListQuestions =
  (
    id: number,
  ): ThunkAction<Promise<void>, State, null, AllListQuestionDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: All_LIST_QUESTION + REQUEST });
    try {
      const payload = await api.loadAllListQuestions(id);
      dispatch({ type: All_LIST_QUESTION + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: All_LIST_QUESTION + FAILURE, error });
    }
  };

export const allListQuestionsIdle = () => ({ type: All_LIST_QUESTION + IDLE });

export const clearAllListQuestions = () => (dispatch: any) => {
  dispatch({ type: All_LIST_QUESTION_CLEAR });
};
